import EventBase from './EventBase'
import EventID from './EventID'

/**
 * 214  -  打开界面
 */

export default class EventCallMenu extends EventBase {
  private readonly DEFAULT_INPUT = '姓,0,0,名,0,0,昵称,0,0,国家,0,0,自定义,0,0'
  /**
   * 打开界面事件构造函数
   */
  public constructor() {
    super()
    this.Parameter = ['10001', '0', '0', this.DEFAULT_INPUT, '']
  }

  // #region 事件内主要属性参数
  /**
   * 界面编号（10001:游戏菜单 10002:剧情回放 10003:CG 10004:BGM 10005:存档 10006:读档 10007环境设置 10008:离开游戏 10009:自动剧情 10010:游戏商城 10011:系统收集 10012:限时商城 10013:福利 10014:起名界面
   */
  get Number() {
    return parseInt(this.Parameter?.[0] ?? '')
  }
  set Number(value) {
    this.Parameter![0] = value.toString()
  }

  get Input() {
    if (!this.Parameter || this.Parameter.length < 4) {
      const arrPara: string[] = new Array(4).fill(0)
      this.Parameter?.forEach((n, i) => {
        arrPara[i] = n
      })
      this.Parameter = arrPara
      this.Parameter[3] = this.DEFAULT_INPUT
    }
    return this.Parameter[3]
  }
  set Input(value) {
    if (!this.Parameter || this.Parameter.length < 4) {
      const arrPara: string[] = new Array(4).fill(0)
      this.Parameter?.forEach((n, i) => {
        arrPara[i] = n
      })
      this.Parameter = arrPara
    }
    this.Parameter[3] = value
  }

  get InputCount():number{
    try {
      let count = Number(this.Parameter[4])
      return count
    } catch (error) {

    }
    return 0
  }

  set InputCount(value:number){
    try {
      this.Parameter[4] = value + ""
    } catch (error) {
      
    }
  }

  // #endregion

  /**
   * 事件ID
   */
  public Code = EventID.CallMenu

  public RefreshInputBox(count: number) {
    // TODO: Why? 好像没啥意义
    const s = this.Input

    const arr = s.split(',')
    const arr_default = this.DEFAULT_INPUT.split(',')

    for (let i = count - 1; i < 5; i++) {
      arr[i * 3] = arr_default[i * 3]
      arr[i * 3 + 1] = arr_default[i * 3 + 1]
      arr[i * 3 + 2] = arr_default[i * 3 + 2]
    }
  }

  /**
   * 获得该事件在事件列表的描述信息
   */
  /// <returns>事件描述信息</returns>
}
